import { ColumnType } from 'antd/es/table'
import renderDate from '../../../../helpers/tables/render-date'
import UserCell from '../../../../components/user-cell/user-cell'
import ReceiptPosition from '../../../../types/api/receipt-position'
import { Link } from 'react-router-dom'

export const columns: ColumnType<ReceiptPosition>[] = [
    {
        dataIndex: 'id',
        title: 'Номер позиции',
        width: 70,
    },
    {
        dataIndex: ['receipt', 'id'],
        title: 'Номер приёмки',
        width: 100,
        render(value) {
            return <Link to={`#`}>{value}</Link>
        },
    },
    {
        dataIndex: ['receipt', 'createdAt'],
        title: 'Дата',
        width: 100,
        render: renderDate,
    },
    {
        dataIndex: ['material', 'material_type', 'name'],
        title: 'Наименование',
        width: 400,
    },
    {
        dataIndex: ['material', 'width'],
        title: 'Ширина',
        width: 100,
    },
    {
        dataIndex: ['length'],
        title: 'Длина (км)',
        width: 100,
    },
    {
        dataIndex: 'createdBy',
        title: 'Создано',
        width: 160,
        render(value, record, index) {
            return <UserCell username={value} />
        },
    },
    {
        dataIndex: 'actions',
        title: '',
        width: 70,
    },
]
